import type {
  CommissionResponse,
  WithdrawSuccessResponse,
} from '@/shared/types';
import { apiClient } from '@/shared/api';
import type { WithdrawSccrsRequestFunction } from '@/features/withdraw-sccrs';

export const getWithdrawCommission = async (
  currencyCode: string,
  amount: string | number,
  onTop?: boolean
): Promise<CommissionResponse> => {
  const response = await apiClient.get<CommissionResponse>(
    `/operations/sccrs/withdraw/commission`,
    {
      params: {
        currencyCode,
        amount,
        ontop: onTop,
      },
    }
  );
  return response.data;
};

export const withdrawSccrs: WithdrawSccrsRequestFunction = async body => {
  const response = await apiClient.post<WithdrawSuccessResponse>(
    `/operations/sccrs/withdraw`,
    body
  );
  return response.data;
};
